import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getViewInfo } from 'axp-data-manager-utils';
import { useDDL } from '@americanexpress/react-ddl';

export const UpdateViewDdl = ({ updateViewData, locale }) => {
  const { updateDDL } = useDDL();
  useEffect(() => {
    if (updateViewData) {
      updateDDL({
        name: 'view',
        value: {
          ...getViewInfo(),
          ...{
            country: locale.split('-')[1],
            language: locale.split('-')[0],
            locale,
            ...updateViewData,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only re-run when updateViewData changes; updateDDL/locale are stable
  }, [updateViewData]);
  return null;
};

export const mapStateToProps = (state) => ({
  updateViewData: state.getIn(['modules', 'axp-prospect-root', 'updateViewData']),
});

UpdateViewDdl.propTypes = {
  locale: PropTypes.string.isRequired,
  updateViewData: PropTypes.objectOf(PropTypes.string),
};

const UpdateViewDDL = UpdateViewDdl;
export default connect(mapStateToProps)(UpdateViewDDL);
